import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';
import { IHighlightedFieldProps } from '../components/highlighted-field/highlighted-field';
import { TextBgType } from '../typings';

export class HighlightedFieldModel extends ContentItem {
  get content(): string {
    return get(this._config, 'elements.content.value', '');
  }

  get bgColor(): TextBgType {
    return get(
      this._config,
      'elements.background_color_snippet__background_color.value[0].codename',
      'light_gray'
    );
  }

  public static create(data: IHightlightedFieldData): IHighlightedFieldProps {
    const { content, bgColor } = new HighlightedFieldModel(data);
    return {
      content,
      bgColor
    };
  }
}
